import React from 'react';
import { useDispatch } from 'react-redux';

import i18n from 'i18n-js';
import { Select, FormControl, MenuItem } from '@material-ui/core';

import { default as ordersStore } from 'store/ordersStore';
import { useStyles } from '../styles';
import { useAppSelector } from 'index';
import { OrderStatus } from 'constants/enums';

export default function PriceLevelSelect() {
    const classes = useStyles();
    const dispatch = useDispatch();
    const orderDetails = useAppSelector((state) => state.orders.orderDetails);
    const priceLevels = useAppSelector(
        (state) => state.restaurantDetails.restaurantInformation.pricingLevels
    );

    function prepareLevels() {
        let result = [];

        if (!!priceLevels?.length) {
            result.push(
                <MenuItem key={'regular-price'} value={''}>
                    {'Regular'}
                </MenuItem>
            );
            priceLevels.forEach((level) =>
                result.push(
                    <MenuItem key={level.id} value={level.id}>
                        {level.name}
                    </MenuItem>
                )
            );
        }

        return result;
    }

    return (
        <>
            <span className={classes.orderDetailsHeadingText} style={{ marginBottom: 20 }}>
                {i18n.t('common.priceLevel')}
            </span>
            <FormControl fullWidth variant="filled">
                <Select
                    defaultValue={''}
                    placeholder={i18n.t('common.selectPriceLevel')}
                    displayEmpty
                    value={orderDetails.priceLevelId ?? ''}
                    renderValue={() =>
                        priceLevels.find((x) => x.id === orderDetails.priceLevelId)?.name ??
                        'Regular'
                    }
                    onChange={(e) => {
                        dispatch(
                            ordersStore.actionCreators.setOrderPriceLevel(
                                orderDetails.id,
                                e.target.value as string
                            )
                        );
                    }}
                    className={classes.responsibleUserSelector}
                    disabled={
                        !orderDetails?.id ||
                        orderDetails.status === OrderStatus.Closed ||
                        orderDetails.status === OrderStatus.Cancelled ||
                        priceLevels?.length < 1 ||
                        orderDetails.orderItems.some((oi) => oi.isPaid) ||
                        !orderDetails.responsibleUserId
                    }
                >
                    {prepareLevels()}
                </Select>
            </FormControl>
        </>
    );
}
